export default __webpack_public_path__ + "static/media/icon_dog.97b5be4f.png";